module.exports = __webpack_public_path__ + "img/ic_phone@2x.7b504efc.png";